export type Rules = Rule[];

export type AllowedPlatform = 'all' | 'mobile_pax' | 'web' | 'offline_sales';

export type Relation =
  | 'allowed_countries'
  | 'forbidden_countries'
  | 'allowed_cities'
  | 'forbidden_cities';

export type Rule =
  | AllowedCountriesRule
  | AllowedPlatformsRule
  | AllowedRelationsRule
  | BlackoutPeriodRule
  | DirectRideRule
  | ForbiddenCountriesRule
  | ForbiddenRelationsRule
  | LineBlacklistRule
  | LineWhitelistRule
  | MinimumTicketsAmountRule
  | MinimumValueRule
  | OfflineSalesRule
  | TravelPeriodRule
  | WeekdaysTravelRule
  | FreeAncillariesRule;

export interface AllowedCountriesRule {
  type: 'allowed_countries';
  countries: string[];
}

export interface AllowedPlatformsRule {
  type: 'allowed_platforms';
  platforms: AllowedPlatform[];
}

export interface AllowedRelationsRule {
  type: 'allowed_relations';
  level: 'CITY' | 'COUNTRY';
  relations: { id: string; from: string; to: string }[];
}

export interface BlackoutPeriodRule {
  type: 'blackout_period';
  id?: string; // for multiple blackout periods
  start?: string;
  end?: string;
}

export interface DirectRideRule {
  type: 'direct_ride';
}

export interface ForbiddenCountriesRule {
  type: 'forbidden_countries';
  countries: string[];
}

export interface ForbiddenRelationsRule {
  type: 'forbidden_relations';
  level: 'CITY' | 'COUNTRY';
  relations: { id: string; from: string; to: string }[];
}

export interface LineBlacklistRule {
  type: 'line_blacklist';
  lines: string[]; // UUIDs (lineId)
}

export interface LineWhitelistRule {
  type: 'line_whitelist';
  lines: string[]; // UUIDs (lineId)
}

export interface MinimumTicketsAmountRule {
  type: 'minimum_tickets_amount';
  count: number;
}

export interface MinimumValueRule {
  type: 'minimum_value';
  value: {
    amount: number;
    currency: string;
  };
}

export interface OfflineSalesRule {
  type: 'offline_sales';
}

export interface TravelPeriodRule {
  type: 'travel_period';
  start?: string; // ISO 8601 date string
  end?: string; // ISO 8601 date string
}

export interface WeekdaysTravelRule {
  type: 'weekdays_travel';
  weekDays: string[]; // Days of the week, e.g., "Monday"
}

export interface FreeAncillariesRule {
  type: 'free_ancillaries';
  ancillaries: FREE_ANCILLARIES[];
}

export enum FREE_ANCILLARIES {
  //eslint-disable-next-line
  PLATFORM_FEE = 'platformFee',
  //eslint-disable-next-line
  SEAT_RESERVATION = 'seatReservation',
}

export const FreeAncillariesMap: Record<FREE_ANCILLARIES, string> = {
  platformFee: 'Platform Fee',
  seatReservation: 'Seat Reservation',
};

export const RulesMap: Record<Rule['type'], string> = {
  allowed_countries: 'Allowed Countries',
  allowed_platforms: 'Allowed Platforms',
  allowed_relations: 'Allowed Relations',
  blackout_period: 'Blackout Period',
  direct_ride: 'Direct Ride',
  forbidden_countries: 'Forbidden Countries',
  forbidden_relations: 'Forbidden Relations',
  line_blacklist: 'Forbidden lines',
  line_whitelist: 'Allowed lines',
  minimum_tickets_amount: 'Minimum Tickets Amount',
  minimum_value: 'Minimum Value',
  offline_sales: 'Offline Sales',
  travel_period: 'Travel Period',
  weekdays_travel: 'Allowed Weekdays',
  free_ancillaries: 'Free Ancillaries',
};
